'use client';

import { c as _c } from "react/compiler-runtime";
import { DocumentoPadraoSituacao } from '@/features/documentosPadrao/components/DocumentoPadraoSituacao';
import type { DocumentoPadrao, DocumentosPadraoSetor } from '@/features/documentosPadrao/types/documentosPadraoTypes';
import { DOCUMENTO_PADRAO_TIPO_LABEL, rotuloEscopo, situacaoValidade } from '@/features/documentosPadrao/utils/documentosPadraoRegras';
import { DropdownMenu } from '@/shared/components/ui/common/DropdownMenu';
import { IconButton } from '@/shared/components/ui/common/IconButton';
import { Table } from '@/shared/components/ui/common/Table';
import * as SubframeCore from '@subframe/core';
import { FeatherArchive, FeatherBuilding, FeatherCopy, FeatherDownload, FeatherEdit3, FeatherFileText, FeatherMoreHorizontal, FeatherTrash2, FeatherUpload, FeatherUser, FeatherUsers } from '@subframe/core';
interface DocumentosPadraoTabelaProps {
  itens: DocumentoPadrao[];
  setores: DocumentosPadraoSetor[];
  referencia: string;
  diasAviso?: number;
  onVerDetalhes: (documento: DocumentoPadrao) => void;
  onEditar: (documento: DocumentoPadrao) => void;
  onSubstituirArquivo: (documento: DocumentoPadrao) => void;
  onBaixar: (documento: DocumentoPadrao) => void;
  onDuplicar: (documento: DocumentoPadrao) => void;
  onArquivar: (documento: DocumentoPadrao) => void;
  onExcluir: (documento: DocumentoPadrao) => void;
}
const CLASSE_CELULA = 'min-h-[72px] py-4';
const iconeEscopo = (documento: DocumentoPadrao) => {
  if (documento.escopo === 'ESCRITORIO') return <FeatherBuilding className="h-3.5 w-3.5" />;
  if (documento.escopo === 'PESSOAL') return <FeatherUser className="h-3.5 w-3.5" />;
  return <FeatherUsers className="h-3.5 w-3.5" />;
};
export function DocumentosPadraoTabela(t0) {
  const $ = _c(26);
  const {
    itens,
    setores,
    referencia,
    diasAviso,
    onVerDetalhes,
    onEditar,
    onSubstituirArquivo,
    onBaixar,
    onDuplicar,
    onArquivar,
    onExcluir
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Table.HeaderRow><Table.HeaderCell className="w-[34%]">Documento</Table.HeaderCell><Table.HeaderCell className="w-[24%]">Vinculado a</Table.HeaderCell><Table.HeaderCell className="w-[19%]">Quem pode usar</Table.HeaderCell><Table.HeaderCell className="w-[19%]">Situação</Table.HeaderCell><Table.HeaderCell className="w-[4%]"> </Table.HeaderCell></Table.HeaderRow>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== diasAviso || $[2] !== itens || $[3] !== onArquivar || $[4] !== onBaixar || $[5] !== onDuplicar || $[6] !== onEditar || $[7] !== onExcluir || $[8] !== onSubstituirArquivo || $[9] !== onVerDetalhes || $[10] !== referencia || $[11] !== setores) {
    let t3;
    if ($[13] !== diasAviso || $[14] !== onArquivar || $[15] !== onBaixar || $[16] !== onDuplicar || $[17] !== onEditar || $[18] !== onExcluir || $[19] !== onSubstituirArquivo || $[20] !== onVerDetalhes || $[21] !== referencia || $[22] !== setores) {
      t3 = documento => {
        const vencida = situacaoValidade(documento.validoAte, referencia, diasAviso) === "VENCIDA";
        return <Table.Row key={documento.id} clickable={true} className={`cursor-pointer ${vencida ? "bg-error-50/40" : ""}`} onClick={() => onVerDetalhes(documento)}><Table.Cell className={CLASSE_CELULA}><div className="flex min-w-0 items-center gap-3"><div className={`flex h-9 w-9 flex-none items-center justify-center rounded-[8px] ${vencida ? "bg-error-100 text-error-700" : "bg-brand-50 text-brand-700"}`}><FeatherFileText className="h-[18px] w-[18px]" /></div><div className="min-w-0"><p className="text-body-bold font-body-bold text-default-font truncate">{documento.nome}</p><p className="text-caption font-caption text-subtext-color truncate">{`${DOCUMENTO_PADRAO_TIPO_LABEL[documento.tipo]} · ${documento.arquivo.nomeArquivo}`}</p></div></div></Table.Cell><Table.Cell className={CLASSE_CELULA}>{documento.parteVinculada ? <div className="min-w-0"><p className="text-body font-body text-default-font truncate">{documento.parteVinculada.nome}</p><p className="text-caption font-caption text-subtext-color">{documento.parteVinculada.cpfCnpj}</p></div> : <div className="min-w-0"><p className="text-body font-body text-subtext-color">Sem vínculo</p><p className="text-caption font-caption text-subtext-color">vale para qualquer parte</p></div>}</Table.Cell><Table.Cell className={CLASSE_CELULA}><div className="text-subtext-color flex min-w-0 items-center gap-1.5">{iconeEscopo(documento)}<span className="text-body font-body text-default-font truncate">{rotuloEscopo(documento.escopo, documento.setoresIds, setores)}</span></div></Table.Cell><Table.Cell className={CLASSE_CELULA}><DocumentoPadraoSituacao validoAte={documento.validoAte} referencia={referencia} diasAviso={diasAviso} /></Table.Cell><Table.Cell className={`justify-end ${CLASSE_CELULA}`} onClick={_temp}><SubframeCore.DropdownMenu.Root><SubframeCore.DropdownMenu.Trigger asChild={true}><IconButton variant="neutral-tertiary" size="small" icon={<FeatherMoreHorizontal />} aria-label={`Ações de ${documento.nome}`} /></SubframeCore.DropdownMenu.Trigger><SubframeCore.DropdownMenu.Portal><SubframeCore.DropdownMenu.Content side="bottom" align="end" sideOffset={4} asChild={true}><DropdownMenu><DropdownMenu.DropdownItem icon={<FeatherEdit3 />} onClick={() => onEditar(documento)}>Editar informações</DropdownMenu.DropdownItem><DropdownMenu.DropdownItem icon={<FeatherUpload />} onClick={() => onSubstituirArquivo(documento)}>Substituir arquivo</DropdownMenu.DropdownItem><DropdownMenu.DropdownItem icon={<FeatherDownload />} onClick={() => onBaixar(documento)}>Baixar</DropdownMenu.DropdownItem><DropdownMenu.DropdownItem icon={<FeatherCopy />} onClick={() => onDuplicar(documento)}>Duplicar</DropdownMenu.DropdownItem><DropdownMenu.DropdownDivider /><DropdownMenu.DropdownItem icon={<FeatherArchive />} onClick={() => onArquivar(documento)}>Arquivar</DropdownMenu.DropdownItem><DropdownMenu.DropdownItem className="text-error-700" icon={<FeatherTrash2 />} onClick={() => onExcluir(documento)}>Excluir</DropdownMenu.DropdownItem></DropdownMenu></SubframeCore.DropdownMenu.Content></SubframeCore.DropdownMenu.Portal></SubframeCore.DropdownMenu.Root></Table.Cell></Table.Row>;
      };
      $[13] = diasAviso;
      $[14] = onArquivar;
      $[15] = onBaixar;
      $[16] = onDuplicar;
      $[17] = onEditar;
      $[18] = onExcluir;
      $[19] = onSubstituirArquivo;
      $[20] = onVerDetalhes;
      $[21] = referencia;
      $[22] = setores;
      $[23] = t3;
    } else {
      t3 = $[23];
    }
    t2 = itens.map(t3);
    $[1] = diasAviso;
    $[2] = itens;
    $[3] = onArquivar;
    $[4] = onBaixar;
    $[5] = onDuplicar;
    $[6] = onEditar;
    $[7] = onExcluir;
    $[8] = onSubstituirArquivo;
    $[9] = onVerDetalhes;
    $[10] = referencia;
    $[11] = setores;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[24] !== t2) {
    t3 = <div className="w-full overflow-x-auto"><Table className="table-fixed" header={t1}>{t2}</Table></div>;
    $[24] = t2;
    $[25] = t3;
  } else {
    t3 = $[25];
  }
  return t3;
}
function _temp(evento) {
  return evento.stopPropagation();
}